import { IPillCard, ITextCard } from '@/utils/interfaces/components';
import { storyblokEditable } from '@storyblok/react';

interface IProps {
  blok: IPillCard;
}

export const PillCard: React.FC<IProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}
      style={{
        boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.08)"
      }}
      className="p-10 text-center bg-white rounded-lg shadow-sm">
      <h3
        style={{ background: `${blok.pill_color}` }}
        className={`text-sm flex items-center w-14 h-9 rounded-[30px] justify-center mx-auto  text-white font-semibold mb-2`}>{blok.heading}</h3>
      <p className=" text-xl my-6 text-center font-bold text-green-dark">{blok.description}</p>
    </div>
  );
};